import { AfterContentInit, Component, Input } from '@angular/core';
import { RelatorioVariavelEstacao } from '../../interfaces/estacao-ultimas-medicoes';
import { numberToBrNumber } from '@utils';
import { ColorUtils } from '@utils/color-utils';
import { corrigeDuplicacaoNome } from '@modulos/home/submodulos/dados-meteorologicos/utils';

@Component({
	selector: 'seira-popup-variaveis-municipio',
	templateUrl: './popup-variaveis-municipio.component.html',
	styleUrls: ['./popup-variaveis-municipio.component.scss'],
})
export class PopupVariaveisMunicipioComponent implements AfterContentInit {
	@Input() estacaoMedicoes: RelatorioVariavelEstacao;
	@Input() nomeVariavel: string;
	@Input() cor: string;
	@Input() generoVariavel: 'o' | 'a' = 'a';
	@Input() unidade = '';
	@Input() isUnidadeNoValor = false;
	@Input() deveMostrarAcumulado = false;
	@Input() deveMostrarMedia = true;

	labelMinimo: string;
	labelMedio: string;
	labelMaximo: string;
	labelSoma: string;
	corTexto: string;
	nomePosto: string;

	ngAfterContentInit(): void {
		this.labelMaximo = numberToBrNumber(this.estacaoMedicoes.valorMax, 1);
		this.labelMinimo = numberToBrNumber(this.estacaoMedicoes.valorMin, 1);
		this.labelMedio = numberToBrNumber(this.estacaoMedicoes.valor, 1);
		this.labelSoma = numberToBrNumber(this.estacaoMedicoes.valorSomado, 1);
		this.corTexto = ColorUtils.ehCorClara(this.cor) ? '#656769' : '#FEFEFE';
		this.nomePosto = corrigeDuplicacaoNome(
			this.estacaoMedicoes.municipio + '/' + this.estacaoMedicoes.nomePosto
		);
	}
}
